import {OverridableComponent} from "@mui/material/OverridableComponent";
import {ListItemIcon, ListItemText, SvgIconTypeMap} from "@mui/material";
import {NavButton} from "../NavButton";

interface NavButtonWithIconProps {
    id: string,
    route: string,
    primaryLabel: string,
    secondaryLabel?: string,
    onClick?: () => void,
    icon: OverridableComponent<SvgIconTypeMap>,
    indent?: boolean,
}

export default function NavButtonWithIcon(
    {id, route, primaryLabel, secondaryLabel, onClick, icon: Icon, indent}: NavButtonWithIconProps,
) {
    return (
        <NavButton id={id}
                   href={route}
                   onClick={onClick}
                   indent={indent}
        >
            <ListItemIcon>
                <Icon/>
            </ListItemIcon>
            <ListItemText primary={primaryLabel} secondary={secondaryLabel}/>
        </NavButton>
    );
}